/* eslint-disable camelcase */
import axios from "axios"; //Limitless

import { formatSimpleDate, ClientContext } from "../../../common/utils";
import { createPublicAPIRequest } from "../../../common/utils/PublicAPIUtils";
import { handleAPIFailure } from "../../../common/utils/api-log-helper/APILogHelper";
export var fetchGroupResponseTime = function fetchGroupResponseTime(callback) {
  var date = new Date();
  var dayYear = "".concat(formatSimpleDate(date, {
    pattern: "DDD"
  }), "-").concat(date.getFullYear());
  var queryParams = {
    groups: ClientContext._groupName,
    view: "day",
    day_number: dayYear,
    stats: "group.response.avgTime",
    readonly: true,
    requester: "customer"
  };
  var apiConfig = createPublicAPIRequest("get", "stats/groups", queryParams); //Ajax call URL, payload, config

  axios(apiConfig).then(function (response) {
    var date = new Date();
    var dayData = 0;

    try {
      dayData = response.data[0].children[date.getFullYear()][0][formatSimpleDate(date, {
        pattern: "D"
      })];
    } catch (event) {
      dayData = 0;
    }

    callback({
      time: dayData
    });
  }).catch(function (error) {
    handleAPIFailure(error, "GroupResponseTimeAPI fetchGroupResponseTime");
    callback({
      time: 0
    });
  });
};